export type AgeGroup = 'youth' | 'adult';

export type TeamInfo = {
  slug: string;
  name: string;
  contentId: string;
  description: string;
  ageGroup: AgeGroup;
  instagramUrl: string;
};

// TODO - Replace Surf School: all four teams share the club's main Instagram account below
// (https://www.instagram.com/siliconvalleyrugby/) - point each at its own account once they exist.
export const TEAMS: TeamInfo[] = [
  {
    slug: 'mens',
    name: "Men's Adult Club",
    contentId: 'team-mens-description',
    // TODO - Replace Surf School: no description text was published on the source site for this card yet.
    description: 'TODO - add description for the Men’s Adult Club.',
    ageGroup: 'adult',
    instagramUrl: 'https://www.instagram.com/siliconvalleyrugby/',
  },
  {
    slug: 'womens',
    name: "Women's Adult Club",
    contentId: 'team-womens-description',
    description:
      'Refine your technique, sharpen your timing, and master new plays. Perfect for those who want to level up.',
    ageGroup: 'adult',
    instagramUrl: 'https://www.instagram.com/siliconvalleyrugby/',
  },
  {
    slug: 'highschool',
    name: 'High School Club',
    contentId: 'team-highschool-description',
    description:
      'Take on bigger challenges with guided training focused on speed, control, and game sense.',
    ageGroup: 'youth',
    instagramUrl: 'https://www.instagram.com/siliconvalleyrugby/',
  },
  {
    slug: 'youth',
    name: 'Youth Club',
    contentId: 'team-youth-description',
    description:
      'Fun, safe, and super exciting! Special programs designed for younger players to fall in love with the game.',
    ageGroup: 'youth',
    instagramUrl: 'https://www.instagram.com/siliconvalleyrugby/',
  },
];
